const globalApi = "https://html-app-backend.onrender.com/api/v1"


export default globalApi